/* eslint-disable camelcase */
import { defineMessages } from 'react-intl';

export default defineMessages({
    isThereExistingPolicy_Ext_AK: {
        id: 'wni.questions.isThereExistingPolicy_Ext.Does the applicant(s) have an existing Umialik Insurance Auto policy or will a Umialik Insurance Auto policy be issued effective within 60 days of the home policy?',
        defaultMessage: 'Does the applicant(s) have an existing Umialik Insurance Auto policy or will a Umialik Insurance Auto policy be issued effective within 60 days of the home policy?'
    }
});
